import { useEffect, useState } from 'react'
import PageHeader from '../layout/PageHeader'
import PageContainer from '../layout/PageContainer'
import DataTable from '../dataTable/DataTable'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import DataInputs from '../dataTable/DataInputs'
import { Card, CardContent, CardHeader } from '@mui/material'
import ImageIcon from '@mui/icons-material/Image'
import axios from 'axios'

const Home = () => {
  const [status_options, setTypeName] = useState([])

  useEffect(() => {
    axios.post('/lookups/photo_statuses', null).then((res) => {
      setTypeName(res.data)
    })
  }, [])

  return (
    <>
      <PageHeader
        icon={<ImageIcon fontSize="large" />}
        title="Zdjęcia"
        subtitle="Tutaj znajdziesz listę zdjęć"
      />
      <PageContainer>
        <StoreKeyProvider storeKey="ImagesKey">
          <WithFilters
            config={{
              page: 1,
              paginate: 10,
              orderType: 'asc',
              order: 'name',
              inputs: {
                name: {
                  value: '',
                  relation: 'LIKE',
                },
                patient_name: {
                  values: '',
                  relation: 'LIKE',
                },
                min_dap: {
                  value: null,
                  relation: 'MIN',
                },
                max_dap: {
                  value: null,
                  relation: 'MAX',
                },
                status_id: {
                  value: 1,
                  relation: 'WHERE',
                },
                min_created_at: {
                  value: null,
                  relation: 'MIN',
                },
                max_created_at: {
                  value: null,
                  relation: 'MAX',
                },
              },
            }}
            endpoint="/photos"
          >
            <Card elevation={2} square>
              <CardHeader title="Lista zdjeć"></CardHeader>
              <CardContent>
                {status_options && (
                  <DataInputs
                    inputs={[
                      {
                        id: 'name',
                        label: 'Nazwa',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'patient_name',
                        label: 'Pacjent',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'dap',
                        label: 'DAP',
                        placeholder: '',
                        type: 'number-between',
                      },
                      {
                        id: 'status_id',
                        label: 'Status',
                        placeholder: '',
                        type: 'select',
                        options: status_options,
                      },
                      {
                        id: 'created_at',
                        label: 'Data wykonania',
                        placeholder: '',
                        type: 'date-between',
                      },
                    ]}
                  />
                )}
                <DataTable
                  breakpoint={1200}
                  actions="ImagesTableActions"
                  labels={[
                    'Nazwa',
                    'Pacjent',
                    'DAP',
                    'Status',
                    'Data wykonania',
                  ]}
                  keys={[
                    'name',
                    'patient_name',
                    'dap',
                    'status_name',
                    'created_at',
                  ]}
                />
              </CardContent>
            </Card>
          </WithFilters>
        </StoreKeyProvider>
      </PageContainer>
    </>
  )
}

export default Home
